<template>
  <div class="mail-config">

    <div class="row">
      <div class="col text-right">
        <button @click.prevent="getAcademicReferences" type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">
          Verficación de referencias académicas <i class="fa fa-envelope"></i>
        </button>
      </div>
    </div>

    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-mail-config">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Verificación de referencias académicas por correo eletrónico</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div :class="`alert ${typeMessage}`" role="alert" id="message-update" v-if="message != ''">
            {{message}}
          </div>                          
          <div class="modal-body">
            <table class="table table-condensed" id="table-academic-references" v-if="showModuleMailer">
              <thead>
                  <tr>
                      <th>Fecha</th>
                      <th>id</th>                      
                      <th>Proceso</th>
                      <th>Tipo</th>
                      <th>Nivel</th>
                      <th>Institución</th>
                      <th>Título</th>
                      <th>Verificada</th>
                      <th>Graduación</th>
                  </tr>
              </thead>
              <tbody v-if="academic_references != null">
                <tr v-for="academic_reference in academic_references" :key="academic_reference.id">
                  <td>{{academic_reference.created_at | parseDate}}</td>
                  <td>{{academic_reference.id}}</td>                  
                  <td>{{academic_reference.project_id}}</td>
                  <td>{{academic_reference.academic_type | academicTypeName }}</td>
                  <td>{{academic_reference.level | levelName }}</td>
                  <td>{{academic_reference.name_institution}}</td>
                  <td>{{academic_reference.name_title}}</td>
                  <td v-if="academic_reference.academic_reference_requested">Si</td>
                  <td v-else>No</td>
                  <td>{{academic_reference.date_graduation}}</td>
                  <td>
                    <button @click.prevent="configure(academic_reference)" type="button" class="btn btn-success">Seleccionar</button>
                  </td>                              
                </tr>
              </tbody>
            </table>
            <div class="show-module-mailer" v-else>
              <table class="table table-condensed" id="table-academic-references">
                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>id</th>
                        <th>Proceso</th>
                        <th>Tipo</th>
                        <th>Nivel</th>
                        <th>Institución</th>
                        <th>Título</th>
                        <th>Graduación</th>
                        <th>Verificada</th>
                        <th>Cerrar</th>
                    </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{academic_reference.created_at | parseDate }}</td>
                    <td>{{academic_reference.id}}</td>
                    <td>{{academic_reference.project_id}}</td>
                    <td>{{academic_reference.academic_type | academicTypeName }}</td>
                    <td>{{academic_reference.level | levelName }}</td>
                    <td>{{academic_reference.name_institution}}</td>
                    <td>{{academic_reference.name_title}}</td>                    
                    <td>{{academic_reference.date_graduation}}</td>
                    <td v-if="academic_reference.academic_reference_requested">Si</td>
                    <td v-else>No</td>
                    <td>
                      <button @click.prevent="close" type="button" class="btn btn-success">cerrar</button>
                    </td>                                                  
                  </tr>
                </tbody>                  
              </table>  
              <confirm-academic-references :academic_reference="academic_reference"/>          
              <div class="form">
                <mail-config-form :academic_reference="academic_reference" :mail_config="mail_config"/>
              </div>
              <div class="form">
                <mail-form :project="project" :academic_reference="academic_reference" :academic_requests="academic_requests"/>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import ConfirmAcademicReferences from './confirm-academic-references.vue'
import MailConfigForm from './mail-config-form.vue'
import MailForm from './mail-form.vue'
export default {
  name: 'MailConfig',
  props: ['project', 'elementary_study_mail_config', 'superior_study_mail_config', 'academic_requests_elementary', 'academic_requests_superior'],
  components: {
    'mail-config-form': MailConfigForm,
    'mail-form': MailForm,
    'confirm-academic-references': ConfirmAcademicReferences
  },
  methods: {
    setCredentials(){
      axios.defaults.headers['x-csrf-token'] = this.token
      axios.defaults.headers.common['Accept'] = 'application/json';
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    },
		showMessage(message, typeMessage){
			this.message = message
			this.typeMessage = typeMessage
			setTimeout(() => this.message = '', 30000)
		},                
    async configure(academic_reference) {      
      this.academic_reference = academic_reference
      let request_mail_config =  await axios.get(`/api/v1/get_mail_config/${this.academic_reference.id}`, {}, {})
      let request_academic_requests =  await axios.get(`/api/v1/get_academic_requests/${this.academic_reference.id}`, {}, {})
      if (request_mail_config.status == 200) {
        this.mail_config = request_mail_config.data.mail_config
      }
      if (request_academic_requests.status == 200) {
        this.academic_requests = request_academic_requests.data.academic_requests
      }
      this.showModuleMailer = false
    },
    async getAcademicReferences () {
      let request_academic_references = await axios.get(`/api/v1/get_academic_references_by_project?project_id=${this.project.id}`, {}, {})
      if (request_academic_references.status == 200) {
        this.academic_references = request_academic_references.data.academic_references
      }
    },
    close () {
      this.showModuleMailer = true
      this.academic_reference = null
      this.mail_config = null
      this.academic_requests = null
    }
  },
  data() {
    return {
			message: '',
      typeMessage: '',      
      token: '',
      mail_config: null,
      academic_requests: null,
      showConfigElmentary: false,
      showConfigSuperior: false,
      showMailElementary: false,
      showMailSuperior: false,
      showModuleMailer: true,
      academic_reference: null,
      academic_references: null
    }
  },
  created () {
    this.token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
  },
  filters: {
    parseDate: function(value) {
      let date = new Date(value)
      let datestring = date.getDate()  + "/" + (date.getMonth()+1) + "/" + date.getFullYear() + " " + date.getHours() + ":" + date.getMinutes();
      return datestring;
    },
    academicTypeName: function (value) {  
      let academic_type_name = ''    
      if (typeof value === 'number') {
        switch (value) {
          case  1:
            academic_type_name = "elemental"
            break;
          case  2:
            academic_type_name = "superior"
            break;        
          default:
            academic_type_name = ""
            break;
        }
      }
      if (academic_type_name != '') {
        value = academic_type_name
      }
      return value
    },    
    levelName: function (value) {
      let level_name = ''
      switch (value) {
        case  0:
          level_name = "Primaria"
          break;
        case  1:
          level_name = "Bachiller"
          break;
        case  2:
          level_name = "Profesional Universitario"
          break;
        case  3:
          level_name = "Técnico Profesional"
          break;
        case  4:
          level_name = "Otro"
          break;
        case  5:
          level_name = "Tecnólogo"
          break;
        case  6:
          level_name = "Especialista"
          break;
        case  7:
          level_name = "Maestria"
          break;
        case  8:
          level_name = "Doctorado"
          break;                                                                                            
        default:
          level_name = ""
          break;
      }
      return level_name
    }
  }
}
</script>

<style scoped>
  .modal-mail-config{
    width: 90% important!;
  }
  .form{
    border-radius: 2px;
    border: 0.2px solid #aaaaaa;
    padding: 20px;
    width: 100%;
    height: 100%;
    margin-bottom: 1rem;
  }
</style>